import { TextInput, Button, Group, Box, Text } from "@mantine/core";
import { useForm, zodResolver } from "@mantine/form";
import { Link, useNavigate } from "react-router-dom";
import { ArrowNarrowLeft } from "tabler-icons-react";

import { Role, useCreateRoleMutation, roleSchema } from "services/api";

const Create = () => {
  const [createRole] = useCreateRoleMutation();
  const form = useForm<Role>({
    validate: zodResolver(roleSchema),
    initialValues: {
      roleNo: "",
      roleName: "",
    },
  });

  const navigate = useNavigate();

  const handleSubmit = async (values: Role) => {
    try {
      await createRole(values).unwrap();

      navigate("../roles", { replace: true });
    } catch (e) {
      if (e.status === 409) {
        form.setFieldError("roleNo", "編號重複");
        return;
      }
    }
  };

  return (
    <Box py={8} px={36}>
      <Text
        variant="link"
        component={Link}
        color="cyan"
        to="../roles"
        underline={false}
        sx={(theme) => ({
          display: "inline-flex",
          alignItems: "center",
          "&:hover": {
            borderBottom: "1px solid" + theme.colors.cyan[6],
          },
        })}
      >
        <ArrowNarrowLeft size={20} /> 返回上一頁
      </Text>
      <h2>新增群組角色</h2>

      <form onSubmit={form.onSubmit(handleSubmit)}>
        <Box>
          <TextInput
            required
            label="角色編號"
            placeholder="1"
            {...form.getInputProps("roleNo")}
          />
          <TextInput
            required
            label="角色名稱"
            placeholder="系統管理員"
            mt="sm"
            {...form.getInputProps("roleName")}
          />
        </Box>
        <Group mt="xl">
          <Button type="submit" color="cyan">
            建立群組角色
          </Button>
        </Group>
      </form>
    </Box>
  );
};

export default Create;
